import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'components';
import classnames from 'classnames';
import { useOnClickOutside } from 'hooks';
import { FaCaretDown } from 'react-icons/fa';

const DropdownBtn = ({ children, primary, secondary, regular, small, className, title }) => {
  const [isMenuShown, setIsMenuShown] = useState(false);
  const dropmenuRef = useRef();
  useOnClickOutside(dropmenuRef, () => setIsMenuShown(false));

  return (
    <div ref={dropmenuRef} className="position-relative">
      <Button
        className="mr-4x"
        primary={primary}
        secondary={secondary}
        small={small}
        regular={regular}
        clickHandler={() => setIsMenuShown(!isMenuShown)}
      >
        {title ? <p> {title} </p> : <p> Add New</p>}
        <FaCaretDown />
      </Button>
      <div className={classnames(`dropmenu`, className, { show: isMenuShown })}>
        <div className="dropmenu__node dropmenu__vertical">{children}</div>
      </div>
    </div>
  );
};

DropdownBtn.propTypes = {
  children: PropTypes.element.isRequired,
  primary: PropTypes.bool,
  secondary: PropTypes.bool,
  small: PropTypes.bool,
  regular: PropTypes.bool,
  className: PropTypes.string,
  title: PropTypes.string,
};

DropdownBtn.defaultProps = {
  primary: false,
  secondary: false,
  small: false,
  regular: true,
  className: '',
};

export default DropdownBtn;
